import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@radix-ui/themes/styles.css";
import "./index.css";
import { Theme } from "@radix-ui/themes";
import App from "./App.tsx";
import { clarity } from "react-microsoft-clarity";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://99ba549a6f4997db175c571e83f804cb@o4509256838676480.ingest.de.sentry.io/4509256839921744",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Initialize Clarity BEFORE rendering
if (typeof window !== "undefined" && !clarity.hasStarted()) {
  clarity.init("ra3164c0nw"); // <-- your real project ID here
}
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Theme>
      <App />
    </Theme>
  </StrictMode>
);
